module.exports = __webpack_public_path__ + "static/media/ts10tj538.3e204d47.png";